export enum MessageType {
    Error,
    Success
}
